<template>
    <div class="main-box">
        <div class="box-header">
            <i class="el-icon-close"></i>
            <span>Order History</span>
        </div>
        <div class="box-content">
            <scroll-wrap>
                <div class="box-content-wrap">

                </div>
            </scroll-wrap>
            <div class="message-alert">

            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Order-History",
        data() {
            return {
                productList: []
            }
        },
        created() {

        },
        methods: {
            getProductList() {
                this.axios.post('/student/buyer/order/cart/list', {}).then(res => {
                    if (res.succeed) {
                        this.productList = res.items;
                    }
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    div.main-box {
        position: relative;
        overflow: hidden;
        border-radius: 0 0 20px 20px;

        &:before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            margin: auto;
            opacity: 0;
            background: rgba(0, 0, 0, 0.5);
            z-index: -1;
            border-radius: 0 0 20px 20px;
            transition: z-index 0s linear 0.3s, opacity 0.3s linear;
        }

        &.mask-layer:before {
            transition: z-index 0s linear 0s;
            opacity: 1;
            z-index: 9998;
        }

        div.box-header {
            position: relative;
            display: flex;
            justify-content: center;
            align-items: center;
            height: 52px;
            line-height: 52px;

            > i {
                position: absolute;
                top: 50%;
                left: 0;
                font-weight: bolder;
                transform: translateY(-50%);
                font-size: 18px;
                padding: 10px;
                cursor: pointer;

                &:hover {
                    opacity: 0.8;
                }
            }

            > span {
                font-size: 18px;
                color: #000000;
                font-weight: bolder;
            }
        }

        div.box-content {
            position: relative;
            height: calc(100% - 104px);
            background: #edf6f9;

            div.box-content-wrap {

            }

            div.message-alert {
                width: 100%;
                padding: 20px 0;
                background: #FFFFFF;
                position: absolute;
                bottom: -300px;
                left: 0;
                z-index: 9999;
                transition: bottom 0.3s linear;
                border-radius: 0 0 22px 22px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;

                &.active {
                    bottom: -52px;
                    transition: bottom 0.3s linear;
                }

                > .img {
                    width: 80px;
                    height: 80px;
                    margin-bottom: 20px;

                    > img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                }

                > .txt {
                    font-weight: bolder;
                    margin-bottom: 10px;
                }

                > .price {
                    font-weight: lighter;
                    font-size: 12px;
                }
            }
        }
    }
</style>
